const baseNavMenuItems = [
  {
    title: 'Home',
    route: 'home',
    icon: 'home',
  },
  {
    title: 'Scans',
    route: 'scans',
    icon: 'scans',
  },
  {
    title: 'Order history',
    route: 'orders',
    icon: 'orders',
  },
  {
    title: 'Account',
    icon: 'account',
    children: [
      // This is array of menu items or menu groups
      // NOTE: You can't use menu header as children
      {
        title: 'Subscription',
        route: 'subscription'
      },
      {
        title: 'Billing',
        route: 'billing'
      },
      
      //{
      //  title: 'Clients',
      //  route: 'users',
      //  icon: 'UsersIcon',
      //},
      {
        title: 'Devices',
        route: 'devices'
      }
    ],
  },
]

export function getNavMenuItems(user, active_account) {
  const hideBillingItems = (user?.main_user != null && user?.separate_bill === false) || (active_account!=null && active_account?.separate_bill === false)
  const isFactory = user?.roles?.includes('ROLE_FACTORY')

  // Factory accounts only see Scans
  if (isFactory) {
    return baseNavMenuItems.filter(item => item.route === 'orders')
  }

  return baseNavMenuItems.map(item => {
    if (!item.children) return item

    return {
      ...item,
      children: item.children.filter(child => {
        if (hideBillingItems) {
          return child.route !== 'subscription' && child.route !== 'billing'
        }
        return true
      }),
    }
  })
}

export default baseNavMenuItems
